import { ImageAttachmentPicker, type ImageAttachmentPickerProps } from '@wapharma/design-system';

/** @deprecated Use ImageAttachmentPicker from @wapharma/design-system */
export type SupportTicketAttachmentPickerProps = ImageAttachmentPickerProps;

/** Thin wrapper — logic lives in design-system ImageAttachmentPicker. */
export function SupportTicketAttachmentPicker(props: ImageAttachmentPickerProps) {
  return <ImageAttachmentPicker {...props} />;
}
